import { z } from 'zod'
import { baseUrl, postJson } from '@/api/http'

const responseSchema = z.object({ status: z.string() })

/**
 * Subscribe an email to a unit watchman. Returns on success; throws
 * (HttpError) on validation or upstream failure so the form can show a real
 * error state.
 */
export async function subscribeLocationWatchman(unitId: number, email: string): Promise<void> {
  await postJson(`${baseUrl}/unit/${unitId}/watchman`, { email }, responseSchema)
}
